import { Box, Button } from '@capitalise/ui-design-system';
import HelpFaces from 'assets/svgs/help-faces.svg';
import { MouseEventHandler } from 'react';

export interface IAccountSetupProps {
  onButtonClick: MouseEventHandler<HTMLButtonElement>;
}

const AccountSetup = ({ onButtonClick }: IAccountSetupProps) => {
  return (
    <>
      <Box display="flex" pb="3xsmall" alignItems="center">
        <HelpFaces />
        <Box pl="3xsmall" display="flex" justifyContent="center" flexDirection="column">
          <Box typography="heading-18">Want some help to get started?</Box>
          <Box typography="body-16">Chat to our Partnership Team</Box>
        </Box>
      </Box>
      <Box display="flex" justifyContent="center">
        <Button variant="outlined" onClick={onButtonClick} baseColor="green">
          Book a demo
        </Button>
      </Box>
    </>
  );
};

export default AccountSetup;
